import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonSnackbarComponent } from 'src/app/_shared/component/common-snackbar/common-snackbar.component';
import { PolygonMapComponent } from 'src/app/_shared/component/polygon-map/polygon-map.component';
import { MarkerCoordinate, MarkerType } from 'src/app/google-map/interface/google-map.interface';
import { opportunityScannerFilterConfig } from 'src/app/opportunity-scanner/opportunity-scanner-filter-config';
import { OpportunityScannerState } from 'src/app/opportunity-scanner/opportunity-scanner.state';
import { PropertyState } from 'src/app/workspace/state/property.state';
import { environment } from 'src/environments/environment';
import { CmaService } from '../cma.service';
import { CmaState } from '../cma.state';

@Component({
  selector: 'app-comparables-recommendations',
  templateUrl: './comparables-recommendations.component.html',
  styleUrls: ['./comparables-recommendations.component.scss'],
})
export class ComparablesRecommendationsComponent implements OnInit {
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild('saveCompsDialog', { static: false }) saveCompsDialog: any;
  @ViewChild('fetchCompsDialog', { static: false }) fetchCompsDialog: any;
  @ViewChild(MatButtonToggleGroup) group!: MatButtonToggleGroup;

  onDestroyNotifier$ = new Subject();
  upgradeSnackbar: MatSnackBarRef<any>;
  roiFilterForm: FormGroup;
  netSellerData: any;
  sortColumnStatus = {};
  filterConfig = opportunityScannerFilterConfig;
  showMap: boolean = false;
  cmaReportData: any;
  selectedOptionForMap: any;
  previousSelectedOptionForMap: any;
  selectedPolygons: any[] = []; //
  filteredPropertyTypeOptions: string[] = [];
  isFetchComps: boolean;
  markerList: MarkerCoordinate[] = [];
  isScreenWidthLarge = true;
  comparablesBaskets = [];
  currentYear: any = moment().format('YYYY');
  reportId: string | null = null;
  cmaReportId: string | null = null;
  selectedComps: any[] = [];
  pageIndex: number = 0;
  isFetchCompsInProgress: any;
  lComparables: any;
  listOfComparables: any;
  selectedComparablesId: string[] = [];
  savedComparablesId: string[] = [];
  listingImageBaseUrl = environment.listingImageBaseUrlAlt;
  private reportFetchedSubject = new Subject<void>();
  dialogRef: any;
  selectAllComps: boolean = false;
  isEdit: boolean = false;
  adjustedFmvByComps: number = 0;
  numberOfSelectedComps: number = 0;
  adjustedFmvBySelectedComps: number = 0;
  listOfComparablesCached: any;
  showAdjustedFMV: boolean = false;
  isFairValueSelected: boolean = false;
  isAdjustedValueSelected: boolean = false;
  isCustomValueSelected: boolean = false;
  customValueTimeout: any;
  customValueDisplay: string = '';
  customValue: number | null = null;
  isSavingValue: boolean = false;
  multiPolygon: string;
  polygonData: any;
  showRadius: boolean = true;
  showPolygon: boolean = false;
  searchMode: any;

  constructor(
    public cmaState: CmaState,
    private cmaService: CmaService,
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private snackbar: MatSnackBar,
    private propertyState: PropertyState,
    private dialog: MatDialog,
    private opScanState: OpportunityScannerState
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isScreenWidthLarge = window.innerWidth > 768;
  }

  ngOnInit(): void {
    this.isScreenWidthLarge = window.innerWidth > 768;
    this.cmaState.openValueAdjustmentsValue = false;
    this.activatedRoute.queryParams.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res && res.id) {
        this.reportId = res.id;
        if (this.reportId) {
          this.getReportDetails(this.reportId, 'edit');
        } else {
          this.openSnackbar('Report Id missing', false);
        }
        this.cdr.detectChanges();
      }
    });

    this.cmaState.cmaReports.pipe().subscribe((res: any) => {
      if (res && res.compReportData) {
        this.comparablesBaskets = [];
        this.cmaReportData = res.compReportData?.valueReport;
        this.cmaReportId = res.cmaReportId;

        if (this.listOfComparablesCached?.length && this.cmaReportData.selectedComps?.length) {
          const selectedMap = new Map(this.cmaReportData.selectedComps.map((comp) => [comp.PMXPropertyId, comp]));
          this.listOfComparablesCached = this.listOfComparablesCached.map(
            (cached) => selectedMap.get(cached.PMXPropertyId) ?? cached
          );
        }

        this.prepareComparablesList(
          this.listOfComparablesCached?.length > 0
            ? JSON.parse(JSON.stringify(this.listOfComparablesCached))
            : JSON.parse(JSON.stringify(this.cmaReportData.selectedComps))
        );

        if (this.selectedComparablesId.length > 0) {
          if (this.selectedComparablesId.length == this.listOfComparables.length) {
            this.savedComparablesId = JSON.parse(JSON.stringify(this.selectedComparablesId));
            this.selectAllComps = true;
          }
          this.selectedComparablesId.forEach((id) => {
            for (let index = 0; index < this.listOfComparables.length; index++) {
              const element = this.listOfComparables[index];
              if (id == element.PMXPropertyId) {
                element.isSelected = true;
                this.comparablesBaskets.push(element);
                this.calculateAdjustedFmvBySelectedComps(element, 'add');
              }
            }
          });
        } else {
          this.selectAllComps = true;
          for (let index = 0; index < this.listOfComparables.length; index++) {
            const element = this.listOfComparables[index];
            element.isSelected = true;
            this.selectedComparablesId.push(element.PMXPropertyId);
            this.comparablesBaskets.push(element);
            this.calculateAdjustedFmvBySelectedComps(element, 'add');
          }
          this.savedComparablesId = JSON.parse(JSON.stringify(this.selectedComparablesId));
        }

        if (this.cmaReportData?.homeValue?.adjustedValue) {
          this.showAdjustedFMV = true;
        }
        if (this.cmaReportData?.searchCriteria?.searchMode) {
          this.searchMode = this.cmaReportData.searchCriteria.searchMode;
          if (this.searchMode == 'RADIUS') {
            this.showRadius = true;
            this.showPolygon = false;
            this.selectedOptionForMap = 'radius';
            if (this.cmaReportData?.searchCriteria?.radius) {
              this.roiFilterForm?.get('radius')?.setValue(this.cmaReportData.searchCriteria.radius);
            }
          } else {
            this.showPolygon = true;
            this.showRadius = false;
            this.selectedOptionForMap = 'polygon';
            if (this.cmaReportData?.searchCriteria?.multiPolygon) {
              this.selectedPolygons = this.wktMultipolygonToArray(this.cmaReportData.searchCriteria.multiPolygon);
            }
          }
        } else {
          this.showRadius = true;
          this.showPolygon = false;
          this.selectedOptionForMap = 'radius';
          this.roiFilterForm?.get('radius')?.setValue(1);
        }

        if (this.cmaReportData?.homeValue?.customValue) {
          this.customValue = this.cmaReportData?.homeValue?.customValue;
          this.customValueDisplay = this.formatCurrencyInput(this.customValue ? this.customValue.toString() : '');
        }

        if (this.cmaReportData?.homeValue?.selectedValueType == 'SALES_COMPARISON_VALUE') {
          this.isFairValueSelected = false;
          this.isAdjustedValueSelected = true;
          this.isCustomValueSelected = false;
        } else if (this.cmaReportData?.homeValue?.selectedValueType == 'CUSTOM_VALUE') {
          this.isFairValueSelected = false;
          this.isAdjustedValueSelected = false;
          this.isCustomValueSelected = true;
        } else {
          this.isFairValueSelected = true;
          this.isAdjustedValueSelected = false;
          this.isCustomValueSelected = false;
        }

        const chunkedArray = this.chunkArray(this.listOfComparables, 10);
        this.lComparables = chunkedArray[0];
        this.generateMarkerList(this.lComparables);
        if (this.paginator) {
          this.paginator.pageIndex = 0; // Reset to the first page
          this.pageIndex = 0; // Sync local `pageIndex` if used
        }
        this.pageChange({});
      }
    });
    setTimeout(() => {
      this.showMap = true;
    }, 1000);
  }

  ngAfterViewChecked() {
    if (this.isFetchComps) {
      if (this.showRadius == true) {
        this.group.value = 'radius';
      } else {
        this.group.value = 'polygon';
      }
      this.cdr.detectChanges();
    }
  }

  drawPolygon() {
    const radius = this.roiFilterForm?.get('radius')?.value;
    this.roiFilterForm?.get('radius')?.setValue(0);
    const matDialogRef = this.dialog.open(PolygonMapComponent, {
      disableClose: true,
      hasBackdrop: true,
      height: '100%',
      width: '100%',
      data: {
        cmaReportData: this.cmaReportData,
        markerList: this.markerList,
        polygons: this.selectedPolygons,
      },
    });

    matDialogRef.afterClosed().subscribe((result) => {
      if (result != null) {
        this.selectedPolygons = Array.from(new Set(result));
      } else if (result === null) {
        // clear button

        this.selectedPolygons = [];
        this.showRadius = true;
        this.showPolygon = false;
        this.selectedOptionForMap = 'radius';

        setTimeout(() => {
          this.roiFilterForm?.get('radius')?.setValue(radius);
          this.cdr.detectChanges();
        }, 100);
      } else if (result === undefined) {
        // cancel button
        if (this.selectedPolygons.length == 0) {
          this.showRadius = true;
          this.showPolygon = false;
          this.selectedOptionForMap = 'radius';

          setTimeout(() => {
            this.roiFilterForm?.get('radius')?.setValue(radius);
            this.cdr.detectChanges();
          }, 100);
        }
      }
      this.cdr.detectChanges();
    });
  }

  mapOption(event) {
    this.selectedOptionForMap = event;
    if (this.selectedOptionForMap == 'polygon') {
      this.showPolygon = true;
      this.showRadius = false;
      if (this.selectedPolygons.length == 0) {
        this.drawPolygon();
      }
    } else if (this.selectedOptionForMap == 'radius') {
      if (this.roiFilterForm?.get('radius')?.value == 0) {
        if (this.cmaReportData?.searchCriteria?.radius) {
          this.roiFilterForm?.get('radius')?.setValue(this.cmaReportData.searchCriteria.radius);
        } else {
          this.roiFilterForm?.get('radius')?.setValue(1);
        }
      }

      this.showRadius = true;
      this.showPolygon = false;
    } else {
      this.showRadius = false;
      this.showPolygon = true;
      this.drawPolygon();
    }
  }

  valuesAdjustedChange(event) {
    if (event) {
      this.showAdjustedFMV = true;
    }
    this.adjustedFmvBySelectedComps = 0;
    this.getReportDetails(this.reportId, 'adjChange');
  }

  prepareComparablesList(comps) {
    this.listOfComparables = comps
      .filter((item) => !!item.PMXPropertyId)
      .sort((a, b) => b.SimilarityScore - a.SimilarityScore)
      .filter((item, index, self) => index === self.findIndex((t) => t.PMXPropertyId === item.PMXPropertyId));

    this.listOfComparablesCached = JSON.parse(JSON.stringify(this.listOfComparables));
  }

  sort(column) {
    for (let key in this.sortColumnStatus) {
      if (key !== column) {
        this.sortColumnStatus[key] = undefined;
      }
    }
    this.sortColumnStatus[column] = this.sortColumnStatus[column] === undefined ? true : !this.sortColumnStatus[column];
    const isAsc = this.sortColumnStatus[column];
    this.listOfComparables.sort((a, b) => {
      switch (column) {
        case 'UnparsedAddress':
          return this.compare(a.UnparsedAddress, b.UnparsedAddress, isAsc);
        case 'StandardStatus':
          return this.compare(a.StandardStatus, b.StandardStatus, isAsc);
        case 'ListPrice':
          return this.compare(a.ListPrice, b.ListPrice, isAsc);
        case 'ClosePrice':
          return this.compare(a.ClosePrice, b.ClosePrice, isAsc);
        case 'CloseDate':
          return this.compare(a.CloseDate, b.CloseDate, isAsc);
        case 'LivingArea':
          return this.compare(a.LivingArea, b.LivingArea, isAsc);
        case 'LotSize':
          return this.compare(a.LotSize, b.LotSize, isAsc);
        case 'Distance':
          return this.compare(a.Distance, b.Distance, isAsc);
        case 'SimilarityScore':
          return this.compare(a.SimilarityScore, b.SimilarityScore, isAsc);
        case 'Bed':
          return this.compare(a.BedroomsTotal, b.BedroomsTotal, isAsc);
        case 'Bath':
          return this.compare(a.BathroomsDecimal, b.BathroomsDecimal, isAsc);
        default:
          return 0;
      }
    });
    this.paginator.pageIndex = 0;
    this.pageIndex = 0;
    this.pageChange({});
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortD(event) {
    console.log(event);
  }

  fetchCompsForm() {
    this.roiFilterForm = this.formBuilder.group({
      // radius: [1],
      radius: this.cmaReportData?.searchCriteria?.radius ? this.cmaReportData?.searchCriteria?.radius : [1],

      monthsBack: [
        this.cmaReportData?.searchCriteria?.monthsBack ? this.cmaReportData?.searchCriteria?.monthsBack : 12,
      ],
      propertySubType: [
        this.cmaReportData?.searchCriteria?.propertyTypeList
          ? this.cmaReportData?.searchCriteria?.propertyTypeList
          : null,
      ],
      minBeds: [
        this.cmaReportData?.searchCriteria?.bedsRange?.from
          ? this.cmaReportData?.searchCriteria?.bedsRange?.from
          : null,
        this.minMaxValidator('min', 'maxBeds'),
      ],
      maxBeds: [
        this.cmaReportData?.searchCriteria?.bedsRange?.to ? this.cmaReportData?.searchCriteria?.bedsRange?.to : null,
        this.minMaxValidator('max', 'minBeds'),
      ],
      minBaths: [
        this.cmaReportData?.searchCriteria?.bathsRange?.from
          ? this.cmaReportData?.searchCriteria?.bathsRange?.from
          : null,
        this.minMaxValidator('min', 'maxBaths'),
      ],
      maxBaths: [
        this.cmaReportData?.searchCriteria?.bathsRange?.to ? this.cmaReportData?.searchCriteria?.bathsRange?.to : null,
        this.minMaxValidator('max', 'minBaths'),
      ],
      minLivingArea: [
        this.cmaReportData?.searchCriteria?.livingAreaRange?.from
          ? this.cmaReportData?.searchCriteria?.livingAreaRange?.from
          : null,
        this.minMaxValidator('min', 'maxLivingArea'),
      ],
      maxLivingArea: [
        this.cmaReportData?.searchCriteria?.livingAreaRange?.to
          ? this.cmaReportData?.searchCriteria?.livingAreaRange?.to
          : null,
        this.minMaxValidator('max', 'minLivingArea'),
      ],
      minYearBuilt: [
        this.cmaReportData?.searchCriteria?.yearBuiltRange?.from
          ? this.cmaReportData?.searchCriteria?.yearBuiltRange?.from
          : null,
        this.minMaxValidator('min', 'maxYearBuilt'),
      ],
      maxYearBuilt: [
        this.cmaReportData?.searchCriteria?.yearBuiltRange?.to
          ? this.cmaReportData?.searchCriteria?.yearBuiltRange?.to
          : null,
        this.minMaxValidator('max', 'minYearBuilt'),
      ],

      //   includeBelowGradeForCalcs: [this.opportunity?.includeBelowGradeForCalcs],

      includeBelowGradedForFetchComps: [this.cmaReportData?.includeBelowGradedForFetchComps == false ? false : true],
    });

    if (!this.roiFilterForm.get('propertySubType')?.value) {
      this.filterPropertyTypeOptions();
    }
  }

  getReportDetails(reportId, type) {
    this.cmaService.getCmaReportById(reportId, type).subscribe({
      next: (response) => {
        if (response.error) {
          console.error('Error fetching report:', response.error);
        }
        this.reportFetchedSubject.next();
      },
      error: (err) => console.error('Unexpected error:', err),
      complete: () => console.log('Subscription completed.'),
    });
  }

  filterPropertyTypeOptions() {
    this.roiFilterForm.get('propertySubType')?.reset();
    if (this.filteredPropertyTypeOptions.length === 1) {
      this.roiFilterForm.get('propertySubType')?.patchValue([this.filteredPropertyTypeOptions[0]]);
    } else {
      this.roiFilterForm.get('propertySubType')?.setValue(null);
    }
  }

  chunkArray(array, size) {
    let i = 1;
    array.forEach((element) => {
      element['index'] = i;
      i = i + 1;
    });
    this.opScanState.comparableList = array;
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  calculateAdjustedFmvBySelectedComps(comp, type) {
    if (type == 'add') {
      if (comp.StandardStatus == 'Sold' && comp?.ClosePrice) {
        this.numberOfSelectedComps = this.numberOfSelectedComps + 1;
        this.adjustedFmvByComps = this.adjustedFmvByComps + Number(comp.ClosePrice);
      } else if (comp.StandardStatus != 'Sold' && comp?.ListPrice) {
        this.numberOfSelectedComps = this.numberOfSelectedComps + 1;
        this.adjustedFmvByComps = this.adjustedFmvByComps + Number(comp.ListPrice);
      }
    } else {
      if (comp.StandardStatus == 'Sold' && comp?.ClosePrice) {
        this.numberOfSelectedComps = this.numberOfSelectedComps - 1;
        this.adjustedFmvByComps = this.adjustedFmvByComps - Number(comp.ClosePrice);
      } else if (comp.StandardStatus != 'Sold' && comp?.ListPrice) {
        this.numberOfSelectedComps = this.numberOfSelectedComps - 1;
        this.adjustedFmvByComps = this.adjustedFmvByComps - Number(comp.ListPrice);
      }
    }
    this.showAdjustedFMV = false;
    this.isAdjustedValueSelected = false;
    this.adjustedFmvBySelectedComps = Number((this.adjustedFmvByComps / this.numberOfSelectedComps).toFixed(0));
  }

  toggleSelectAllComps(event) {
    let markerList = JSON.parse(JSON.stringify(this.markerList));
    this.markerList = [];
    this.cdr.detectChanges();

    if (event.checked) {
      this.selectAllComps = true;
      this.selectedComparablesId = [];
      this.comparablesBaskets = [];

      let total = 0;
      let count = 0;

      for (let i = 0; i < this.listOfComparables.length; i++) {
        let comp = this.listOfComparables[i];
        comp['isSelected'] = true;

        if (comp.PMXPropertyId) {
          this.selectedComparablesId.push(comp.PMXPropertyId);
          this.comparablesBaskets.push(comp);
        }

        const value = comp.StandardStatus === 'Sold' ? Number(comp.ClosePrice) : Number(comp.ListPrice);

        if (value) {
          total += value;
          count++;
        }
      }

      this.adjustedFmvByComps = total;
      this.numberOfSelectedComps = count;
      this.adjustedFmvBySelectedComps = Math.round(total / count);
    } else {
      this.selectAllComps = false;
      this.selectedComparablesId = [];
      this.comparablesBaskets = [];
      this.numberOfSelectedComps = 0;
      this.adjustedFmvByComps = 0;
      this.adjustedFmvBySelectedComps = 0;

      if (this.cmaReportData?.homeValue?.adjustedValue) {
        this.showAdjustedFMV = true;
      }

      for (let i = 0; i < this.lComparables.length; i++) {
        let comp = this.lComparables[i];
        comp['isSelected'] = false;
        markerList[i].isSelected = false;
      }

      for (let i = 0; i < this.listOfComparables.length; i++) {
        let comp = this.listOfComparables[i];
        comp['isSelected'] = false;
      }
    }

    this.markerList = JSON.parse(JSON.stringify(markerList));
    this.cdr.detectChanges();
  }

  toggleSelect(comp: any, index: number, event: MatCheckboxChange): void {
    let markerList = JSON.parse(JSON.stringify(this.markerList));
    this.markerList = [];
    this.cdr.detectChanges();

    if (comp.isSelected) {
      this.selectAllComps = false;
      this.comparablesBaskets = this.comparablesBaskets.filter((item) => item.PMXPropertyId !== comp.PMXPropertyId);
      comp['isSelected'] = false;
      markerList[index].isSelected = false;
      let idx = this.selectedComparablesId.indexOf(comp.PMXPropertyId);
      if (comp.PMXPropertyId && comp.PMXPropertyId != '' && idx !== -1) {
        this.selectedComparablesId.splice(idx, 1);
      }
      this.calculateAdjustedFmvBySelectedComps(comp, 'remove');
    } else {
      let idx = this.selectedComparablesId.indexOf(comp.PMXPropertyId);
      if (comp.PMXPropertyId && comp.PMXPropertyId != '' && idx < 0) {
        this.comparablesBaskets.push(comp);
        this.selectedComparablesId.push(comp.PMXPropertyId);
        this.calculateAdjustedFmvBySelectedComps(comp, 'add');
        comp['isSelected'] = true;
        markerList[index].isSelected = true;
      }
    }
    this.markerList = JSON.parse(JSON.stringify(markerList));
    this.cdr.detectChanges();
  }

  viewComps(comp) {
    this.propertyState.propertyDetailsSheetInput = comp;
  }

  generateMarkerList(comparableList: any[]): void {
    if (comparableList && comparableList.length > 0) {
      this.markerList = comparableList.map((comparable) => {
        return {
          lat: comparable?.Latitude ? comparable?.Latitude : '0',
          lng: comparable?.Longitude ? comparable?.Longitude : '0',
          label: comparable.index.toString(),
          type: this.getMarkerType(comparable?.StandardStatus),
          isSelected: comparable?.isSelected ? true : false,
          payload: {
            id: comparable.index,
          },
        };
      });
    }
  }

  getMarkerType(status?: string): MarkerType {
    let markerType: MarkerType;
    switch (status) {
      case 'Sold':
        markerType = 'sold';
        break;

      case 'Active':
      case 'Active Under Contract':
        markerType = 'active';
        break;

      default:
        markerType = 'sold';
        break;
    }
    return markerType;
  }

  fetchComps() {
    this.previousSelectedOptionForMap = this.selectedOptionForMap;
    this.isFetchComps = true;
    if (this.reportId) this.getReportDetails(this.reportId, 'edit');
    this.fetchCompsForm();
    this.filteredPropertyTypeOptions =
      this.filterConfig.propertyTypeMapping[this.cmaReportData.subject.PropertySubType] || [];

    this.markerList = [];
    this.reportFetchedSubject.next();
  }

  pageChange(event) {
    let limit = event?.pageSize || 10;
    let offset = event?.pageIndex || 0;

    const chunkedArray = this.chunkArray(this.listOfComparables, limit);
    this.lComparables = chunkedArray[offset];
    this.generateMarkerList(this.lComparables);
  }

  validateYear(year: any, formValueName: string, minField: string, maxField: string) {
    year = year.value;
    const control = this.roiFilterForm.get(formValueName);
    if (isNaN(year) || year.length !== 4 || year < 1000 || year > this.currentYear) {
      const minControl = this.roiFilterForm.get(minField);
      const maxControl = this.roiFilterForm.get(maxField);
      if (!minControl.value && !maxControl.value) {
        minControl.setErrors(null);
        maxControl.setErrors(null);
      } else {
        control.setErrors({ invalidYear: true });
      }
      return;
    } else {
      control.setErrors(null);
    }
    this.validateMinMaxYears(minField, maxField);
  }

  minMaxValidator(type: string, supportCtrlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!this.roiFilterForm?.get(supportCtrlName)?.value || !control.value) return null;
      let minMaxError = false;
      if (type === 'min' && +control.value > +this.roiFilterForm.get(supportCtrlName)?.value) {
        minMaxError = true;
      } else if (type === 'max' && +this.roiFilterForm.get(supportCtrlName).value > +control.value) {
        minMaxError = true;
      }
      if (minMaxError) {
        control.markAsTouched();
        this.roiFilterForm?.markAsTouched();
        return { minMaxError: true };
      }
      return null;
    };
  }

  validateMinMaxYears(minField: string, maxField: string) {
    const minControl = this.roiFilterForm.get(minField);
    const maxControl = this.roiFilterForm.get(maxField);
    if (minControl.value && maxControl.value && minControl.value > maxControl.value) {
      minControl.setErrors({ maxMinYear: true });
      maxControl.setErrors({ maxMinYear: true });
    } else {
      minControl.setErrors(null);
      maxControl.setErrors(null);
    }
  }

  openNetSeller() {
    this.cmaState.openNetSellerSheetValue = true;
  }

  closeDialog() {
    this.isFetchComps = false;
    if (this.previousSelectedOptionForMap == 'radius') {
      this.selectedOptionForMap = 'radius';
      if (this.roiFilterForm?.get('radius')?.value == 0) {
        if (this.cmaReportData?.searchCriteria?.radius) {
          this.roiFilterForm?.get('radius')?.setValue(this.cmaReportData.searchCriteria.radius);
        } else {
          this.roiFilterForm?.get('radius')?.setValue(1);
        }
      }
      this.showRadius = true;
      this.showPolygon = false;
    } else if (this.previousSelectedOptionForMap == 'polygon' || this.previousSelectedOptionForMap == 'redrawPolygon') {
      this.selectedOptionForMap = 'polygon';
      this.showRadius = false;
      this.showPolygon = true;
    }
    this.generateMarkerList(this.lComparables);
    this.cdr.detectChanges();
  }

  arrayToWktMultipolygon(data: Array<Array<{ lat: number; lng: number }>>): string {
    const polygons = data.map((polygon) => {
      const ring = [...polygon];
      const first = ring[0];
      const last = ring[ring.length - 1];
      if (first.lng !== last.lng || first.lat !== last.lat) {
        ring.push({ lat: first.lat, lng: first.lng });
      }
      const coords = ring.map((p) => `${p.lng} ${p.lat}`).join(', ');
      return `((${coords}))`;
    });
    return `MULTIPOLYGON(${polygons.join(', ')})`;
  }

  wktMultipolygonToArray(wkt: string): Array<Array<{ lat: number; lng: number }>> {
    const wktData = wkt.replace(/^MULTIPOLYGON\s*\(\s*/i, '').replace(/\)\s*$/, '');
    const polygonStrings =
      wktData
        .match(/\(\([^()]+\)\)/g) // match (( ... ))
        ?.map((p) => p.replace(/^\(\(/, '').replace(/\)\)$/, '')) || [];
    const polygons = polygonStrings.map((polyStr) => {
      const points = polyStr.split(',').map((pair) => {
        const [lng, lat] = pair.trim().split(/\s+/).map(Number);
        return { lat, lng };
      });
      return points;
    });
    return polygons;
  }

  fetchCompsSubmit() {
    let radius = this.roiFilterForm.get('radius').value;
    let monthsBack = this.roiFilterForm.get('monthsBack').value;
    if (this.selectedOptionForMap === 'radius' && (radius < 1 || radius > 5)) {
      this.openSnackbar('Radius needs to be between 1 to 5 miles', false);
      return;
    }
    if (monthsBack < 1 || monthsBack > 24) {
      this.openSnackbar('Months back needs to be between 1 to 24 months', false);
      return;
    }
    if (this.comparablesBaskets.length > 0) {
      this.dialogRef = this.dialog.open(this.fetchCompsDialog);
    } else {
      this.fetchComparables(true);
    }
  }

  fetchComparables(flag?: boolean) {
    if (this.dialogRef) {
      this.dialogRef.close();
    }

    this.isFetchCompsInProgress = true;
    const payload = {
      referenceId: this.cmaReportId,
      ...this.roiFilterForm.value,
    };

    if (
      (this.selectedOptionForMap == 'polygon' || this.selectedOptionForMap == 'redrawPolygon') &&
      this.selectedPolygons.length != 0
    ) {
      this.multiPolygon = this.arrayToWktMultipolygon(this.selectedPolygons);
      if (this.multiPolygon) {
        payload.multiPolygon = this.multiPolygon;
      }
      delete payload.radius;
    } else if (this.selectedOptionForMap == 'radius') {
      delete payload.multiPolygon;
    }

    this.cmaService.getCmaFetchComparables(payload).subscribe(
      (res: any) => {
        if (res?.data?.comparables) {
          this.selectAllComps = false;
          this.isFetchCompsInProgress = false;
          if (flag) {
            this.listOfComparables = JSON.parse(JSON.stringify(this.comparablesBaskets));
          } else {
            this.comparablesBaskets = [];
            this.selectedComparablesId = [];
            this.listOfComparables = [];
            this.numberOfSelectedComps = 0;
            this.adjustedFmvByComps = 0;
            this.adjustedFmvBySelectedComps = 0;
          }
          this.savedComparablesId = [];

          for (let index = 0; index < res.data.comparables.length; index++) {
            const element = res.data.comparables[index];

            const pmxPropertyId = element?.pmxPropertyId;

            // Skip if already exists
            const alreadyExists = this.listOfComparables.some((item) => item.PMXPropertyId === pmxPropertyId);

            if (alreadyExists) {
              continue;
            }

            this.listOfComparables.push({
              PMXPropertyId: element?.pmxPropertyId,
              ListingId: element?.listingId,
              UnparsedAddress: element?.address?.streetAddress,
              City: element?.address?.city,
              StateOrProvince: element?.address?.state,
              PostalCode: element?.address?.zip,
              StandardStatus: element?.listingRecord?.StandardStatus
                ? element?.listingRecord?.StandardStatus
                : element?.publicRecord?.StandardStatus,
              ListPrice: element?.listingRecord?.ListPrice
                ? Number(element?.listingRecord?.ListPrice)
                : Number(element?.publicRecord?.ListPrice || 0),
              ListingContractDate: element?.listingRecord?.ListingContractDate
                ? element?.listingRecord?.ListingContractDate
                : element?.publicRecord?.ListingContractDate,
              ClosePrice: element?.listingRecord?.ClosePrice
                ? Number(element?.listingRecord?.ClosePrice)
                : Number(element?.publicRecord?.ClosePrice || 0),
              CloseDate: element?.listingRecord?.CloseDate
                ? element?.listingRecord?.CloseDate
                : element?.publicRecord?.CloseDate,
              BedroomsTotal: element?.listingRecord?.BedroomsTotal
                ? element?.listingRecord?.BedroomsTotal
                : element?.publicRecord?.BedroomsTotal
                ? element?.publicRecord?.BedroomsTotal
                : element?.bedroomsTotal,
              BathroomsDecimal: element?.listingRecord?.BathroomsDecimal
                ? element?.listingRecord?.BathroomsDecimal
                : element?.publicRecord?.BathroomsDecimal
                ? element?.publicRecord?.BathroomsDecimal
                : element?.bathroomsTotal,
              LivingArea: element?.listingRecord?.LivingArea
                ? Number(element?.listingRecord?.LivingArea)
                : element?.publicRecord?.LivingArea
                ? Number(element?.publicRecord?.LivingArea)
                : Number(element?.livingArea || 0),
              LotSizeSquareFeet: element?.listingRecord?.LotSizeSquareFeet
                ? Number(element?.listingRecord?.LotSizeSquareFeet)
                : element?.publicRecord?.LotSizeSquareFeet
                ? Number(element?.publicRecord?.LotSizeSquareFeet)
                : Number(element?.lotSizeSquareFeet || 0),
              Distance: element?.distanceToSubject,
              SimilarityScore: element?.userRecord?.SimilarityScore,
              Latitude: element?.listingRecord?.Latitude
                ? element?.listingRecord?.Latitude
                : element?.publicRecord?.Latitude
                ? element?.publicRecord?.Latitude
                : element?.lat,
              Longitude: element?.listingRecord?.Longitude
                ? element?.listingRecord?.Longitude
                : element?.publicRecord?.Longitude
                ? element?.publicRecord?.Longitude
                : element?.lng,
            });
          }
          this.prepareComparablesList(JSON.parse(JSON.stringify(this.listOfComparables)));

          const chunkedArray = this.chunkArray(this.listOfComparables, 10);
          this.lComparables = chunkedArray[0];
          this.generateMarkerList(this.lComparables);
          this.isFetchComps = false;
          if (this.paginator) {
            this.paginator.pageIndex = 0; // Reset to the first page
            this.pageIndex = 0; // Sync local `pageIndex` if used
          }
        } else if (res.data && !res.data.comparables) {
          this.isFetchCompsInProgress = false;
          this.openSnackbar('No comparables found for the current criteria. Please adjust the map or filters.', false);
        }
      },
      (err) => {
        this.isFetchCompsInProgress = false;
        console.log('create report err', err);
        this.openSnackbar(err.error.message, false);
      }
    );
  }

  saveComparables(type: string) {
    if (this.comparablesBaskets.length < 1) {
      this.openSnackbar('Select at least one comparable to proceed', false);
      return;
    }
    this.isSavingValue = true;
    let selectedComparables = [];

    const subject = this.cmaReportData?.subject;

    for (let index = 0; index < this.comparablesBaskets.length; index++) {
      const element = this.comparablesBaskets[index];

      if (element.PMXPropertyId === subject.PMXPropertyId) {
        continue;
      }

      if (element?.ListingId) {
        selectedComparables.push({
          listingId: element?.ListingId,
          pmxPropertyId: element?.PMXPropertyId,
        });
      } else {
        selectedComparables.push({
          pmxPropertyId: element?.PMXPropertyId,
        });
      }
    }

    let params = {
      referenceId: this.cmaReportId,
      selectedComps: selectedComparables,
    };

    this.cmaService
      .saveSelectedComparables(params, type)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(({ isLoading, data }) => {
        if (data) {
          this.savedComparablesId = JSON.parse(JSON.stringify(this.selectedComparablesId));
          this.isSavingValue = false;
          if (type != 'silent') {
            // this.toggleSelectValue('SALES_COMPARISON_VALUE');
            this.getReportDetails(this.reportId, type);
          }
        }
      });
  }

  valueAdjustment() {
    if (this.comparablesBaskets.length < 1) {
      this.openSnackbar('Select at least one comparable to proceed', false);
      return;
    }
    if (this.cmaReportData?.homeValue?.adjustedValue) {
      let flag = true;
      for (let index = 0; index < this.comparablesBaskets.length; index++) {
        const element = this.comparablesBaskets[index];
        if (!element.AdjustmentInfo) {
          flag = false;
          break;
        }
      }
      if (flag) {
        this.isEdit = true;
      }
    }
    this.cmaState.openValueAdjustmentsValue = true;
    // const subject = this.cmaReportData?.subject;
    // if (!this.comparablesBaskets.includes(subject)) {
    //   this.comparablesBaskets.unshift(subject);
    // }
    this.cmaState.adjustmentValue = this.comparablesBaskets;
    this.saveComparables('silent');
  }

  close() {
    if (!this.selectedComparablesId) this.selectedComparablesId = [];
    if (!this.savedComparablesId) this.savedComparablesId = [];
    if (this.arraysHaveSameElements(this.selectedComparablesId, this.savedComparablesId)) {
      if (window?.history?.state?.from && window?.history?.state?.from == 'comp') {
        this.router.navigate(['/cma/view'], { queryParams: { id: this.reportId }, state: { from: 'comp' } });
      } else if (window?.history?.state?.from && window?.history?.state?.from == 'reportCard') {
        this.router.navigate(['/cma']);
      } else {
        this.router.navigate(['/cma/view'], { queryParams: { id: this.reportId } });
      }
    } else {
      this.dialogRef = this.dialog.open(this.saveCompsDialog);
    }
  }

  closeSaveCompsDialog() {
    this.dialogRef.close();
    this.cdr.detectChanges();
  }

  closeFetchCompsDialog() {
    this.dialogRef.close();
    this.cdr.detectChanges();
  }

  skipSaving() {
    this.closeSaveCompsDialog();
    this.router.navigate(['/cma/view'], { queryParams: { id: this.reportId } });
  }

  saveCompsAndProceed() {
    this.closeSaveCompsDialog();
    this.saveComparables('active');
    this.router.navigate(['/cma/view'], { queryParams: { id: this.reportId } });
  }

  openSnackbar(upgradeMsg, success = false) {
    this.upgradeSnackbar = this.snackbar.open(upgradeMsg, 'Dismiss', {
      duration: 5000,
      panelClass: [success ? 'snackbar-success' : 'snackbar-error'],
      verticalPosition: 'top',
    });
  }

  arraysHaveSameElements(arr1: string[], arr2: string[]): boolean {
    return arr1.length === arr2.length && arr1.sort().every((value, index) => value === arr2.sort()[index]);
  }

  onCustomValueInput(value: string) {
    const numericValue = value.replace(/[^0-9.]/g, '');
    this.customValueDisplay = this.formatCurrencyInput(numericValue);
    this.customValue = parseFloat(numericValue);
    if (!this.isCustomValueSelected) return;
    clearTimeout(this.customValueTimeout);
    this.customValueTimeout = setTimeout(() => {
      if (this.customValue != null && !isNaN(this.customValue)) {
        const params = {
          referenceId: this.cmaReportId,
          selectedValueType: 'CUSTOM_VALUE',
          selectedValue: this.customValue,
        };
        this.isSavingValue = true;
        this.cmaService
          .saveAdjustedValueSelection(params)
          .pipe(takeUntil(this.onDestroyNotifier$))
          .subscribe(({ isLoading, data }) => {
            if (data) {
              this.openSnackBarWithRedirection('Report updated successfully with your custom value');
              //   this.openSnackbar('Custom value saved successfully', true);
              this.isSavingValue = false;
            }
          });
      }
    }, 3000);
  }

  openSnackBarWithRedirection(message?: string) {
    this.snackbar.openFromComponent(CommonSnackbarComponent, {
      data: {
        message: message || 'Report updated successfully',
        primaryButtonLabel: 'View Report',
        secondaryButtonLabel: 'Dismiss',
        redirectUrl: {
          path: ['/cma/view'],
          queryParams: { id: this.reportId },
        },
      },
      verticalPosition: 'top',
      panelClass: ['snackbar-success'],
      duration: undefined,
    });
  }

  formatCurrencyInput(value: string): string {
    if (!value) return '';
    const parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  toggleSelectValue(type) {
    if (type == 'AVM_VALUE') {
      if (this.isFairValueSelected) {
        this.isFairValueSelected = false;
      } else {
        this.isFairValueSelected = true;
      }
      this.isAdjustedValueSelected = false;
      this.isCustomValueSelected = false;
    } else if (type == 'SALES_COMPARISON_VALUE') {
      if (this.isAdjustedValueSelected) {
        this.isAdjustedValueSelected = false;
      } else {
        this.isAdjustedValueSelected = true;
      }
      this.isFairValueSelected = false;
      this.isCustomValueSelected = false;
    } else if (type == 'CUSTOM_VALUE') {
      if (this.isCustomValueSelected) {
        this.isCustomValueSelected = false;
      } else {
        this.isCustomValueSelected = true;
      }
      this.isFairValueSelected = false;
      this.isAdjustedValueSelected = false;
    }

    this.cdr.detectChanges();
    if (this.isFairValueSelected || this.isAdjustedValueSelected || this.isCustomValueSelected) {
      let selectedValue = null;
      if (this.isFairValueSelected) {
        selectedValue = this.cmaReportData?.homeValue?.avm.value;
      } else if (this.isAdjustedValueSelected) {
        selectedValue = this.showAdjustedFMV
          ? this.cmaReportData?.homeValue?.adjustedValue
          : this.adjustedFmvBySelectedComps;
      } else if (this.isCustomValueSelected && this.customValue) {
        selectedValue = this.customValue;
      }

      let params = {
        referenceId: this.cmaReportId,
        selectedValueType: type,
        selectedValue: selectedValue,
      };

      if (!params.selectedValue) {
        return;
      }
      this.isSavingValue = true;
      this.cmaService
        .saveAdjustedValueSelection(params)
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe(({ isLoading, data }) => {
          if (data) {
            if (type === 'SALES_COMPARISON_VALUE') {
              this.openSnackBarWithRedirection('Report updated successfully with your Model Adjusted Value');
            } else if (type === 'AVM_VALUE') {
              this.openSnackBarWithRedirection('Report updated successfully with the selected Starting value.');
            } else if (type === 'CUSTOM_VALUE') {
              this.openSnackBarWithRedirection('Report updated successfully with your custom value.');
            } else {
              this.openSnackbar('Value selection saved successfully', true);
            }
            this.isSavingValue = false;
          }
        });
    }
  }
}
